<template>
  <div class="account-system">
    <router-view></router-view>
    <footer @click="goJump()">&copy;2014-2016 京ICP备13001365号-1 北京屏芯科技有限公司版权所有</footer>
  </div>
</template>
<script>
  export default {
    methods: {
      goJump () {
        window.open('https://beian.miit.gov.cn/');
      }
    }
  };
</script>
<style lang="less">
  .account-system {
    .main {
      margin: 140px auto 60px;
    }
    .el-form {
      .el-input {
        width: auto;
      }
      .el-input__inner {
        width: 360px;
        height: 36px;
      }
      .el-form-item__label {
        padding-right: 30px;
      }
      .sm-input {
        .el-input__inner {
          width: 216px;
        }
        .sm-input-right {
          width: 130px;
          height: 36px;
          margin-left: 14px;
        }
      }
      .el-radio+.el-radio {
        margin-left: 100px;
      }
      .el-button {
        width: 360px;
        height: 40px;
      }
    }
    .el-step {
      .el-step__head {
        width: 60px;
        height: 60px;
        border-style: solid;
        border-width: 2px;
        &.is-wait {
          color: #fff;
          background-color: #bfcbd9;
          border-color: #bfcbd9;
        }
        .el-step__line {
          height: 6px;
          top: 30px;
          left: 64px;
          .el-step__line-inner {
            border-width: 3px !important;
          }
        }
        .el-step__icon {
          line-height: 60px;
          font-size: 30px;
          height: 60px;
        }
      }
      .el-step__main {
        margin-left: -4px !important;
        .is-process.el-step__title {
          color: #999;
        }
      }
      &:last-child .el-step__main {
        text-align: center;
      }
    }
    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 30px;
      line-height: 30px;
      border-top: 1px solid #dcdcdc;
      color: #9b9b9b;
      font-size: 12px;
      text-align: center;
      background: #fff;
      z-index: 999;
    }
  }
</style>



// WEBPACK FOOTER //
// AccountSystem.vue?358d1380